
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeCruiseOutlined as ObiVesselTypeCruiseOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-cruise-outlined.js';
 
 
 

 
 export const ObiVesselTypeCruiseOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-cruise-outlined',
   elementClass: ObiVesselTypeCruiseOutlinedElement,
   events: {
     
   }
  });
 
 